<div class="backdrop">
    <div class="modal">
        <h1 class="modal__title">
            {{ 'shared.confirmation_modal.title' | translate }}
        </h1>

        <p class="modal__description">
            {{ question$ | async }}
        </p>

        <button class="modal__button" (click)="confirmAction()">
            {{
                (confirmText$ | async)
                    ? (confirmText$ | async)
                    : ('shared.confirmation_modal.confirm' | translate)
            }}
        </button>

        <button
            class="modal__button modal__button--secondary"
            (click)="cancelAction()"
        >
            {{ 'shared.confirmation_modal.cancel' | translate }}
        </button>
    </div>
</div>
